import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["error"]
  static values = { schema: { type: String, default: "array" } }

  validate(event) {
    const textarea = event?.target || this._findTextarea()
    const errorTarget = this.errorTarget

    if (!textarea) return

    try {
      const json = JSON.parse(textarea.value)

      if (this.schemaValue === "array" && !Array.isArray(json)) {
        throw new Error("Value must be a JSON array")
      }

      if (this.schemaValue === "object" && (json === null || Array.isArray(json) || typeof json !== "object")) {
        throw new Error("Value must be a JSON object")
      }

      const formattedJson = JSON.stringify(json, null, 2)

      if (textarea.value !== formattedJson) {
        textarea.value = formattedJson
      }

      textarea.classList.remove("border", "border-red-500")
      errorTarget.textContent = ""
    } catch (error) {
      textarea.classList.add("border", "border-red-500")
      errorTarget.textContent = `Invalid JSON: ${error.message}`
    }
  }

  connect() {
    const textarea = this._findTextarea()
    if (textarea && textarea.value && textarea.value.trim() !== '') {
      this.validate({ target: textarea })
    }
  }

  _findTextarea() {
    if (this.element.tagName === "TEXTAREA") return this.element
    return this.element.querySelector("textarea")
  }
}
